import { useNavigate } from "react-router-dom"
import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { PageHeader } from "../../../../../../shared/components/pageHeader/PageHeader"
import { Page } from "../../../../../../shared/components/pageHeader/PageHeaderApi"
import { useApiMutation } from "../../../../../../core/api/useApiMutation"
import {
    COMPANY_ADMIN_DATA_IMPORT_BILL_RECEIVERS_RESULT_ROUTE,
    COMPANY_ADMIN_ROUTE,
} from "../../../../../../constants/routes"
import { useCurrentCompany } from "../../../../hooks/useCurrentCompany"
import {
    Breadcrumb,
    BreadcrumbLink,
    StandardBreadcrumbs,
} from "../../../../../../shared/components/links/StandardBreadcrumbs"
import { ImportBillReceiversForm } from "../components/ImportBillReceiversForm"
import { importBillReceivers } from "../importBillReceiversApi"

export function CompanyImportBillReceivers() {
    const { companyId } = useCurrentCompany()
    const navigate = useNavigate()
    const { mutate: callImportBillReceivers } = useApiMutation(importBillReceivers, {
        async onSuccess(_, data) {
            navigate(COMPANY_ADMIN_DATA_IMPORT_BILL_RECEIVERS_RESULT_ROUTE, {
                state: { importResult: data.importResult },
            })
        },
    })

    return (
        <>
            <LocalizedStrict id="company-data-import-bill-receivers-title" attrs={{ title: true }}>
                <PageHeader page={Page.COMPANY_ADMINS_DATA_IMPORT_BILL_RECEIVERS} title="Import bill receivers">
                    <StandardBreadcrumbs>
                        <LocalizedStrict id="company-nav-item-home">
                            <BreadcrumbLink to={COMPANY_ADMIN_ROUTE}>Home</BreadcrumbLink>
                        </LocalizedStrict>
                        <LocalizedStrict id="company-nav-item-data-import">
                            <Breadcrumb>Data import</Breadcrumb>
                        </LocalizedStrict>
                        <LocalizedStrict id="company-nav-item-import-bill-receivers">
                            <Breadcrumb>Bill receivers</Breadcrumb>
                        </LocalizedStrict>
                    </StandardBreadcrumbs>
                </PageHeader>
            </LocalizedStrict>
            <ImportBillReceiversForm
                onSubmit={(data) => {
                    callImportBillReceivers({ importData: data, companyId: companyId })
                }}
            />
        </>
    )
}
